import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Box,
    TextField,
    Button,
} from "@mui/material";
import { MecordColors } from "Constants/Color";

interface StatusRemarkModalProps {
    open: boolean;
    onClose: () => void;
    onSubmit: () => void;
    remark: string;
    onRemarkChange: (value: string) => void;
    isUpdating?: boolean;
    title?: string;
    placeholder?: string;
}

const StatusRemarkModal: React.FC<StatusRemarkModalProps> = ({
    open,
    onClose,
    onSubmit,
    remark,
    onRemarkChange,
    isUpdating = false,
    title = "Add Remark for Status Change",
    placeholder = "Enter reason or comments for status change...",
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            PaperProps={{
                sx: { borderRadius: "12px", p: 1 },
            }}
        >
            <DialogTitle sx={{ fontWeight: 700, pb: 1 }}>{title}</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 1 }}>
                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        placeholder={placeholder}
                        value={remark}
                        onChange={(e) => onRemarkChange(e.target.value)}
                        variant="outlined"
                        sx={{
                            "& .MuiOutlinedInput-root": {
                                borderRadius: "8px",
                            },
                        }}
                    />
                </Box>
            </DialogContent>
            <DialogActions sx={{ p: 2, pt: 0, justifyContent: "center" }}>
                <Button
                    variant="text"
                    className="px-3 px-md-4"
                    style={{
                        backgroundColor: MecordColors.LightThemeBGColor,
                        color: MecordColors.ActiveText,
                        textDecoration: "none",
                        border: "1px solid transparent",
                        transition: "border-color 0.15s ease-in-out",
                    }}
                    onClick={onClose}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.borderColor = MecordColors.ActiveText;
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.borderColor = "transparent";
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    className="px-3 px-md-4"
                    style={{
                        backgroundColor: MecordColors.ThemeBGColor,
                        borderColor: MecordColors.ThemeBGColor,
                        color: "#fff",
                        transition:
                            "background-color 0.15s ease-in-out, border-color 0.15s ease-in-out",
                        textTransform: "none",
                    }}
                    onClick={onSubmit}
                    disabled={isUpdating}
                    onMouseEnter={
                        !isUpdating
                            ? (e) => {
                                e.currentTarget.style.backgroundColor = "#c82333";
                                e.currentTarget.style.borderColor = "#c82333";
                            }
                            : undefined
                    }
                    onMouseLeave={
                        !isUpdating
                            ? (e) => {
                                e.currentTarget.style.backgroundColor =
                                    MecordColors.ThemeBGColor;
                                e.currentTarget.style.borderColor = MecordColors.ThemeBGColor;
                            }
                            : undefined
                    }
                    sx={{
                        boxShadow: "none",
                        "&:hover": {
                            boxShadow: "none",
                        },
                    }}
                >
                    {isUpdating ? (
                        <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                                role="status"
                                aria-hidden="true"
                            ></span>
                            Updating...
                        </>
                    ) : (
                        "Submit"
                    )}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default StatusRemarkModal;
